import { SET_SEARCH, RESET_SEARCH, SET_PRESERVE_SEARCH, RESET_ALL_PRESERVE_SEARCH } from "./type";

const initialPreserveSearch = {
    customer: false,
    lead: false,
    task: false,
    product: false,
    vendor: false,
    salesOrder: false,
    invoice: false,
    template : false,
    workflow : false
};

const initialState = {
  customer: {},
  lead: {},
  task : {},
  product : {},
  vendor: {},
  salesOrder : {},
  invoice : {},
  template : {},
  workflow : {},
  preserveSearch: initialPreserveSearch
};

const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SEARCH: {
      const { module, values } = action.payload;

      return {
        ...state,
        [module]: {
          ...state[module],
          ...values,
        },
      };
    }

    case RESET_SEARCH: {
     const { module, values } = action.payload;
      return {
        ...state,
        [module]: {
          ...values,
      },
    }
    }

    case SET_PRESERVE_SEARCH: {
      const { entity, value } = action.payload;
      return {
        ...state,
        preserveSearch: {
          ...state.preserveSearch,
          [entity]: value,
        },
      };
    }
    
    case RESET_ALL_PRESERVE_SEARCH: {
    return {
        ...state,
        preserveSearch: {
            ...initialPreserveSearch,
        },
    };
}

    default:
      return state;
  }
};

export default searchReducer;